import { ComponentProps, FC } from 'react';

import { IconButton } from '../Button';
import { StyledExpandToggle } from './ExpandToggle.styled';

type ExpandToggleProps = Omit<ComponentProps<typeof IconButton>, 'color' | 'variant' | 'size'>;

export const ExpandToggle: FC<ExpandToggleProps> = ({ children, ...rest }) => (
  <StyledExpandToggle variant="ghost" color="tertiary" size="xs" {...rest}>
    {children}
  </StyledExpandToggle>
);
